document.addEventListener('DOMContentLoaded', function() {
  (function() {

    // リサイズ時にPC表示になったらbodyのoverflowをリセット
    let resizeTimer;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {
        if (window.innerWidth > 999) {
          document.body.style.overflow = '';
        }
      }, 250);
    });

    // 第1階層：トップレベルのトリガー
    document.addEventListener('click', function(e) {
      const topLevelTrigger = e.target.closest('[data-top-level-trigger]');
      if (!topLevelTrigger) return;

      const nav = topLevelTrigger.closest('.c-accordion-menu');
      if (!nav) return;

      const wrapper = nav.querySelector('.c-accordion-menu__wrapper');
      if (!wrapper) return;

      const isOpening = !wrapper.classList.contains('c-is-open');

      wrapper.classList.toggle('c-is-open');
      topLevelTrigger.classList.toggle('c-is-open');

      if (window.innerWidth <= 999) {
        document.body.style.overflow = isOpening ? 'hidden' : '';
      }
    });

    // 第2階層：セカンドレベルのトリガー
    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('[data-second-level-trigger]');
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      const nav = trigger.closest('.c-accordion-menu');
      if (!nav) return;

      const secondLevelDiv = trigger.closest('.c-accordion-menu__second-level');
      if (!secondLevelDiv) return;

      // 他の同レベルのアコーディオンを閉じる
      nav.querySelectorAll('.c-accordion-menu__second-level').forEach(item => {
        if (item !== secondLevelDiv) {
          item.classList.remove('c-is-open');
        }
      });
      // 現在のアコーディオンの状態を切り替え
      secondLevelDiv.classList.toggle('c-is-open');
    });

    // 第3階層：サードレベルのトリガー
    document.addEventListener('click', function(e) {
      const trigger = e.target.closest('[data-third-level-trigger]');
      if (!trigger) return;

      e.preventDefault();
      e.stopPropagation();

      const thirdLevelItem = trigger.closest('.c-accordion-menu__third-level-item');
      if (!thirdLevelItem) return;

      const parent = thirdLevelItem.closest('.c-accordion-menu__third-level');
      if (!parent) return;

      // 同じ親内の他のアコーディオンを閉じる
      parent.querySelectorAll('.c-accordion-menu__third-level-item').forEach(item => {
        if (item !== thirdLevelItem) {
          item.classList.remove('c-is-open');
        }
      });

      // 現在のアコーディオンの状態を切り替え
      thirdLevelItem.classList.toggle('c-is-open');
    });

  })();
});